import { withInstall } from '@lit-element/utils'
import Result from './src/result.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtResult: SFCWithInstall<typeof Result> = withInstall(Result)

export default LtResult

export * from './src/result'
